import { render, staticRenderFns } from "./CsvFileIcon.vue?vue&type=template&id=6c4a58cf&"
import script from "./CsvFileIcon.vue?vue&type=script&lang=js&"
export * from "./CsvFileIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports